module.exports = __webpack_public_path__ + "img/schnittkante_zinkgelb_ral1018.95344e21.jpg";